var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "#9a9a9a",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5989 11.732C15.3485 11.4496 15.0053 11.2656 14.6309 11.2128L10.5829 10.508C9.80212 10.3664 9.02932 10.7992 8.74292 11.54C7.75812 10.952 6.86132 10.228 6.07892 9.38801C5.43092 8.69521 4.87172 7.92401 4.41492 7.09201C5.18452 6.88641 5.68532 6.14721 5.59092 5.35601L5.07892 1.40401C5.03412 1.05601 4.87012 0.733613 4.61492 0.492013C4.25492 0.128013 3.74772 -0.0495871 3.23892 0.0120129L1.59092 0.220013C0.910917 0.308813 0.356517 0.808813 0.198917 1.47601C-0.513083 4.46801 0.694917 8.32401 3.64692 11.468C6.39092 14.4128 9.89492 16.0128 12.9669 16.0128C13.4309 16.0136 13.8941 15.9736 14.3509 15.892C15.0197 15.7888 15.5509 15.2768 15.6797 14.6128L15.9669 13.0128C16.0445 12.5512 15.9093 12.0816 15.5989 11.732Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4a3a84d6c70919cac615bf9450473105.svg";
export { ForwardRef as ReactComponent };